module.exports = __webpack_public_path__ + "static/img/dest-markers.f61e11c2.png";